import React from 'react';
import {
    BrowserRouter as Router,
    Link
} from "react-router-dom";

function Home() {
    return (
        <div>
            <h1>Certificate Inquiry Form</h1>

            <p>
                <Link to="/phytosanitary">Phytosanitary Certificate</Link>
            </p>
            <p>
                <Link to="/treatment">Treatment Certificate</Link>
            </p>
            <p>
                <Link to="/nursery">Nursery Certificate</Link>
            </p>
        </div>
    );
}

export default Home;